import { render } from "./Measure.vue?vue&type=template&id=20d2f7ae"
import script from "./Measure.vue?vue&type=script&lang=js"
export * from "./Measure.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__